exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".SongLink {\n  text-align: center; }\n  .SongLink:hover {\n    color: #2385ff; }\n    .SongLink:hover .SongLink-image {\n      opacity: 0.7; }\n  .SongLink:active {\n    color: #074797; }\n  .SongLink-image {\n    width: 100%;\n    height: auto;\n    transition: opacity 0.1s; }\n  .SongLink-title {\n    margin: 8px 0 0;\n    color: #0068e9;\n    line-height: 24px; }\n  .SongLink-artist {\n    color: #0b1c31;\n    line-height: 24px; }\n", ""]);

// exports
